import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Phase 21 — light-weight polling hook for the current worker's open
 * time_entry. Used by the Running-time HUD + tab title flip.
 *
 * Polls every 15 s (jittered by ±1 s) to keep the HUD fresh without
 * hammering the API. Rethinking later if this grows we can switch to
 * SSE, but for the HUD the polling budget is tiny.
 */
export function useOpenTimeEntry({ enabled = true, intervalMs = 15000 } = {}) {
  const [entry, setEntry] = useState(null);
  const [task, setTask] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    let timer = null;

    const load = async () => {
      try {
        const { data } = await api.get("/time/current");
        if (cancelled) return;
        const oe = data?.open_entry || null;
        setEntry(oe);
        if (oe?.task_id) {
          try {
            const tr = await api.get(`/tenant/tasks/${oe.task_id}`);
            if (!cancelled) setTask(tr.data);
          } catch (e) {
            if (!cancelled) setTask(null);
          }
        } else {
          setTask(null);
        }
        setError(null);
      } catch (e) {
        if (!cancelled) setError(e);
      } finally {
        if (!cancelled) {
          const jitter = 1000 * (Math.random() - 0.5);
          timer = setTimeout(load, intervalMs + jitter);
        }
      }
    };
    load();

    return () => {
      cancelled = true;
      if (timer) clearTimeout(timer);
    };
  }, [enabled, intervalMs]);

  return { entry, task, error };
}
